import { createServerFn } from "@tanstack/react-start";
import { getServerCacheQueryClient } from "@/network/cache-query-client";
import { QueryKeysConfig } from "@/config/query-keys";
import { getPosts as makeRequest } from "@/network/queries/get-posts";
import { loggingMiddleware } from "../middleware/server-fn/logging";
import * as v from "valibot";

const Schema = v.object({
  after: v.optional(v.pipe(v.string(), v.maxLength(256))),
});

export const getPosts = createServerFn({ method: "GET" })
  .middleware([loggingMiddleware])
  .validator((data: v.InferInput<typeof Schema> = {}) => v.parse(Schema, data))
  .handler(async ({ data }) => {
    const res = await getServerCacheQueryClient().ensureQueryData({
      queryKey: [QueryKeysConfig.rootPosts, data],
      queryFn: () => makeRequest(data),
      revalidateIfStale: true,
    });
    return res;
  });
